import { BUTTON_SUBMISSION, PRICING_BENEFITS, PREFERRED_PRICING } from "../constants";

export const priceBook = () => {
  const trackEvent = (event) => {
    digitalData.event = digitalData.event || [];
    digitalData.event.push(event);
  };

  const priceBookEvents = {
    clickShopNow: ({ output }) => {
      const { category } = output;
      const DDOEvent = {
        category: {
          primaryCategory: BUTTON_SUBMISSION,
        },
        eventInfo: {
          eventName: "my account settings",
        },
        myAccount: {
          settings: `${PRICING_BENEFITS}: shop now button: ${category}`,
        },
      };
      trackEvent(DDOEvent);
    },

    clickRequestPackage: () => {
      const DDOEvent = {
        category: {
          primaryCategory: BUTTON_SUBMISSION,
        },
        eventInfo: {
          eventName: "my account settings",
        },
        myAccount: {
          settings: `${PRICING_BENEFITS}: your selected package: request a package switch link`,
        },
      };
      trackEvent(DDOEvent);
    },

    clickRequestPackageSwitch: () => {
      const DDOEvent = {
        category: {
          primaryCategory: BUTTON_SUBMISSION,
        },
        eventInfo: {
          eventName: "my account settings",
        },
        myAccount: {
          settings: `${PREFERRED_PRICING}: pack switch embed reg: request package switch`,
        },
      };
      trackEvent(DDOEvent);
    },

    clickContinuePackageSwitch: () => {
      const DDOEvent = {
        category: {
          primaryCategory: BUTTON_SUBMISSION,
        },
        eventInfo: {
          eventName: "my account settings",
        },
        myAccount: {
          settings: `${PREFERRED_PRICING}: pack switch embed reg: request package switch continue`,
        },
      };
      trackEvent(DDOEvent);
    },

    packageSwitchSubmitted: ({ output }) => {
      const { packageName } = output;
      const formattedName = String(packageName || "").toLowerCase().replace(/-/g, " ");
      
      const DDOEvent = {
        category: {
          primaryCategory: BUTTON_SUBMISSION,
        },
        eventInfo: {
          eventName: "my account settings",
        },
        myAccount: {
          settings: `${PREFERRED_PRICING}: pack switch embed reg: submission: ${formattedName}`,
        },
      };
      trackEvent(DDOEvent);
    },
  };

  window.LIFE_CYCLE_EVENT_BUS.on("pricebook.click-shopnow", priceBookEvents.clickShopNow);
  window.LIFE_CYCLE_EVENT_BUS.on("pricebook.click-requestpackage", priceBookEvents.clickRequestPackage);
  window.LIFE_CYCLE_EVENT_BUS.on("pricebook.click-requestpackageswitch", priceBookEvents.clickRequestPackageSwitch);
  window.LIFE_CYCLE_EVENT_BUS.on("pricebook.click-continuepackageswitch", priceBookEvents.clickContinuePackageSwitch);
  window.LIFE_CYCLE_EVENT_BUS.on("pricebook.packageswitch-submitted", priceBookEvents.packageSwitchSubmitted);
};
